import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface StatCardProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
}
export function StatCard({
  label,
  value,
  icon,
  trend,
  className = ''
}: StatCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} className={`bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl p-5 ${className}`} data-id="element-617">
      <div className="flex items-start justify-between" data-id="element-618">
        <div className="flex-1 min-w-0" data-id="element-619">
          <p className="text-sm text-[#666666] mb-1" data-id="element-620">{label}</p>
          <p className="text-2xl font-bold text-white truncate" data-id="element-621">{value}</p>
          {trend && <div className={`flex items-center gap-1 mt-2 text-sm ${trend.isPositive ? 'text-[#22C55E]' : 'text-[#EF4444]'}`} data-id="element-622">
              {trend.isPositive ? <TrendingUpIcon className="w-3.5 h-3.5" data-id="element-623" /> : <TrendingDownIcon className="w-3.5 h-3.5" data-id="element-624" />}
              <span data-id="element-625">
                {trend.isPositive ? '+' : ''}
                {trend.value}%
              </span>
              <span className="text-[#666666]" data-id="element-626">vs tháng trước</span>
            </div>}
        </div>
        <div className="p-2.5 bg-[#C8A84E]/10 rounded-lg text-[#C8A84E] flex-shrink-0" data-id="element-627">
          {icon}
        </div>
      </div>
    </motion.div>;
}